export default function getErrorMessage(error: unknown, fallbackMessage = 'An unexpected error occurred') {
  return error instanceof Error ? error.message : fallbackMessage;
}
